import { atomWithStorage, createJSONStorage } from 'jotai/utils';

/** How long dismissing hides the card before it may show again. */
export const MOBILE_HANDOFF_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

export const MOBILE_HANDOFF_DISMISSED_AT_KEY = 'heidi:work-mobile-handoff-dismissed-at';

/**
 * Epoch ms of the last dismiss, or null when never dismissed. `getOnInit` reads
 * storage on first access, so a snoozed user never renders the card (or fires
 * its `viewed` impression) for the one frame before storage would load. The
 * default JSON storage guards `window.localStorage`, so the eager read is safe
 * during the Node prerender, where a bare `localStorage` would throw.
 */
export const mobileHandoffDismissedAtAtom = atomWithStorage<number | null>(
  MOBILE_HANDOFF_DISMISSED_AT_KEY,
  null,
  createJSONStorage<number | null>(),
  { getOnInit: true }
);

export const isMobileHandoffSnoozed = (
  dismissedAt: number | null,
  now: number = Date.now()
): boolean => dismissedAt !== null && now - dismissedAt < MOBILE_HANDOFF_SNOOZE_MS;
